export interface OrderQueryParam {
  type: 'asc' | 'desc' | 'none'
  column: string
}

export function orderQueryParamObjectToString(param: OrderQueryParam) {
  const orderType = param?.type === 'desc' ? '-' : ''
  const column = param?.column
  return `${orderType}${column}`
}
